import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PushNotificationService } from './shared/services/push-notification/push-notification.service';
import { filter } from 'rxjs';
import { ScreenAccessLogService, ScreenCode } from './shared/services/screen-access-log/screen-access-log.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

 export class AppComponent {
  showHeader = false; 

  constructor(private router: Router, private _pushNotificationService: PushNotificationService, private screenAccessLog: ScreenAccessLogService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        this.showHeader =
          url !== '/login' &&
          url !== '/404' &&
          !url.startsWith('/redefinir-senha');
      });

    this._pushNotificationService.listenForMessages();
  }

  ngOnInit(): void {
  
}
}

